import { useState, useEffect } from "react";
import { LoaderCircle } from "lucide-react";

const ThinkingIndicator = () => {
    const messages = [
        "Thinking...",
        "Agent is analyzing...",
        "Processing your request...",
        "Generating a response...",
        "Almost there...",
        "Finalizing details...",
    ];

    const [currentMessage, setCurrentMessage] = useState(messages[0]);
    const [fade, setFade] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(true); // Start fade-out
            setTimeout(() => {
                setCurrentMessage((prev) => {
                    const nextIndex = (messages.indexOf(prev) + 1) % messages.length;
                    return messages[nextIndex];
                });
                setFade(false); // Start fade-in
            }, 300); // Fade-out duration
        }, 2000); // Message switch interval

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="absolute -top-9 left-1/2 transform -translate-x-1/2 px-4 py-2 bgPrimary customBorder border-bottom-0 rounded-t-[10px] text-[var(--text-primary)] w-[90%] flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center">
                <LoaderCircle size={20} className="animate-spin text-[var(--primary-color)]" />
            </div>
            <span
                className={`whitespace-nowrap transition-opacity duration-500 ${fade ? "opacity-0" : "opacity-100"
                    }`}
            >
                {currentMessage}
            </span>
        </div>
    );
};

export default ThinkingIndicator;
